import { Container, Col, Row } from "react-bootstrap";
import {Typewriter} from "react-simple-typewriter";

import "../styles/feature.css"

export const Feature = () => {
    return (
        <Container fluid>
            <Row className="feature-backcolor">
                <Col sm={8}>
                <div className="feature-boarder">
                    <div style={{ padding: "5%", fontFamily: "monospace" }}>
                        <h4 className="feature-intro"> 
                            <span style={{ color: "green"}}>[... ~]$ whoami </span> 
                        </h4>
                        <h4 className="feature-intro">Doug Zuniga</h4>
                        <p className="feature-intro">I'm a
                            <span style={{ color: "green", fontWeight: "bold", whiteSpace: "nowrap" }}>
                                <Typewriter
                                    words={[" Software Developer!", " System Administrator!", " Designer!", " Freelancer!"]}
                                    loop
                                    cursor
                                    cursorStyle="_"
                                    typeSpeed={70}
                                    deleteSpeed={50}
                                    delaySpeed={1000}
                                />
                            </span>
                        </p>
                    </div>
                </div>
                </Col>
                <Col sm={4} className="feature-diagonal-stripes">
                </Col>
            </Row>
            <Row>

            </Row>
        </Container>
    );
}